<template>
  <div class="container" v-loading="pageLoadingState">
    <div class="main-container">
      <!-- 订阅头部 -->
      <subs-card class="mb-32 keyInfo" ref="keyInfo">
        <template #header>
          <div style="display: flex; justify-content: space-between;">
            <div>
              <div class="header-title">{{ detailState.merchantCustId || noDataString }} {{
                $t('message.subscription.hasSubscription') }} {{ detailState.productName || noDataString }}</div>
              <span :style="getSubscriptionStatusStyle(detailState.subscriptionStatus)" class="subs-icon">{{
                getEnantiomericValue(statusesList, detailState.subscriptionStatus) }}</span>
            </div>
            <!-- 合同生效才允许取消订阅 或 合同取消但订阅状态为激活 -->
            <div class="cancel-subs-btn pointer" v-if="detailState.dataStatus === '1' || (detailState.dataStatus === '3' && detailState.subscriptionStatus === 'active')" @click="unsubscribeClick">
              {{ $t('message.subscription.cancelSubsBtn') }}</div>
          </div>
        </template>
        <template #body>
          <div class="txn-info">
            <div class="txn-info-item">
              <div class="title">{{ $t('message.subscription.contractId') }}</div>
              <div class="text">{{ detailState.contractId || noDataString }}</div>
            </div>
            <div class="txn-info-item">
              <div class="title">{{ $t('message.subscription.nextCollectionTime') }}</div>
              <div class="text">{{ detailState.billingCycleAnchor || noDataString }}</div>
            </div>
            <div class="txn-info-item">
              <div class="title">{{ $t('message.subscription.nextCollectionAmount') }}</div>
              <div class="text">{{ (detailState.orderAmount || noDataString) + ' ' + (detailState.orderCurrency ||
                noDataString) }}</div>
            </div>
            <div class="txn-info-item">
              <div class="title">{{ $t('message.subscription.timeliness') }}</div>
              <div class="text">{{ (detailState.createDate || noDataString) + ' ~ ' + (detailState.expireDate ||
                'Permanent') }}</div>
            </div>
          </div>
        </template>
      </subs-card>

      <!-- 订阅信息 -->
      <subs-card class="mb-32 subscriptionInfo" ref="subscriptionInfo">
        <template #header>
          <div style="display: flex; justify-content: space-between;">
            <div class="header-title">{{ $t('message.subscription.subsInfo') }}</div>
            <!-- 订阅状态为激活，合同状态为生效 才允许编辑 -->
            <div class="pointer operation-btn" style="color: #503DF6;"
              v-if="detailState.subscriptionStatus === 'active' && detailState.dataStatus === '1' && detailState.selfExecute != '2'"
              @click="editClick">
              <img src="@/views/subscription/order/detail/image/icon_edit.png" alt="">
              {{ $t('message.subscription.editBtn') }}
            </div>
          </div>
        </template>
        <template #body>
          <el-descriptions :column="2" :colon="false" :label-style="textWidthByLang"
            :content-style="{ color: '#1A202C' }">
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.collectionMethod')">
              {{ getEnantiomericValue(paymentMethodList, detailState.selfExecute) }}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.transactionUrl')">{{
              detailState.website || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.trailEndDate')">{{
              detailState.trialEnd || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.productName')">{{
              detailState.productName || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.startDate')">{{
              detailState.createDate || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.productPrice')">{{
              detailState.productPrice || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.endDate')">{{
              detailState.expireDate || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.productQuantity')">{{
              detailState.productCount || noDataString }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label">
              <template slot="label">
                {{ $t('message.subscription.billingCounts') }}
                <el-popover placement="right" :width="400" popper-class="popper-dark" trigger="hover">
                  <div v-html="$t('message.subscription.billingCountsTips')"></div>
                  <template #reference>
                    <img style="vertical-align:sub;width:16px;height:16px;cursor:pointer;margin-left: 8px;"
                      src="@/assets/images/base/icon-note.png" />
                  </template>
                </el-popover>
              </template>
              <template slot="default">
                {{ detailState.currentCycleCount ?? noDataString }}/{{ detailState.cycleCount || noDataString }}
              </template>
            </el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.billingAmount')">
              {{ detailState.orderAmount + ' ' + detailState.orderCurrency }}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.billingFrequency')">
              {{ $t(`message.subscription._frequencyData.${detailState.frequencyType}`, {
                value:
                  detailState.frequencyPoint }) }}
            </el-descriptions-item>
          </el-descriptions>
        </template>
      </subs-card>
      <!-- 顾客信息 -->
      <subs-card class="mb-32 customerInformation" ref="customerInformation"
        :title="$t('message.subscription.customerInformation')">
        <template #body>
          <el-descriptions :column="2" :colon="false" :label-style="textWidthByLang"
            :content-style="{ color: '#1A202C' }">
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.customerId')">{{
              detailState.merchantCustId }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.email')">{{
              detailState.notificationEmail }}</el-descriptions-item>
            <el-descriptions-item label-class-name="desc-label" :label="$t('message.subscription.paymentMethods')">
              {{ (detailState.cardType || noDataString) + ' ' }}
              {{ detailState.afterCard ? `**** **** **** ${detailState.afterCard}` : noDataString }}
            </el-descriptions-item>
          </el-descriptions>
        </template>
      </subs-card>

      <!-- 扣款历史 -->
      <subs-card class="mb-32 deductionHistory">
        <template #header>
          <div style="display: flex; justify-content: space-between;">
            <div class="header-title">{{ $t('message.subscription.deductionHistory') }}</div>
            <div v-permission="'subscribe:query:txnDownload'" class="pointer operation-btn" style="color: #503DF6;"
              @click="exportClick">
              <img src="@/views/subscription/order/detail/image/icon_download.png" alt="">
              {{ $t('message.subscription.exportBtn') }}
            </div>
          </div>
        </template>
        <template #body>
          <custom-table :table-set="historyTableCondition" :is-first-visit="false"
            :additionalParameters="{ ...$route.query }" :service-function="getSubscriptionTxnHistory"
            router-name="/subscription/order/detail" ref="tableRefState">
          </custom-table>
        </template>
      </subs-card>
    </div>

    <div class="side-menu-container">
      <div class="side-menu">
        <div class="text" style="font-weight: bold;">{{ $t('message.subscription.quickAccess') }}</div>
        <div v-for="item in sideMenuList" class="pointer text" :class="sideIndexState === item.key ? 'active' : ''"
          :key="item.key" @click="clickSideMenu(item.key)">{{ $t(item.label) }}</div>
      </div>
    </div>

    <unsubscribe-dialog ref="unsubscribeDialogRefState" @success="init()"></unsubscribe-dialog>
    <edit-dialog ref="editDialogRefState" @success="init()"></edit-dialog>

  </div>
</template>

<script>

import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getSubscription, getSubscriptionTxnHistory, exportSubscriptionDetail } from '@/views/subscription/api/subscription';
import { getFrequencyDescription } from '@/views/subscription/utils';

import EditDialog from './components/editDialog.vue';
import SubsCard from './components/subs-card.vue';
import unsubscribeDialog from './components/unsubscribeDialog.vue';

export default {
  components: {
    EditDialog,
    CustomTable,
    SubsCard,
    unsubscribeDialog,
  },
  data() {
    return {
      noDataString: '--',
      contractId: '',
      type: '',
      detailState: {},
      statusesList: [],
      paymentMethodList: [],
      historyListState: [],
      txnStatusesList: [],
      pageLoadingState: false,
      sideMenuList: [
        { key: 'keyInfo', label: 'message.subscription.keyInfo' },
        { key: 'subscriptionInfo', label: 'message.subscription.subscriptionInfo' },
        { key: 'customerInformation', label: 'message.subscription.customerInformation' },
        { key: 'deductionHistory', label: 'message.subscription.deductionHistory' },
      ],
      sideIndexState: 'keyInfo',
      historyTableCondition: [
        {
          key: 'txnSerialNumber',
          titleBar: {
            title: 'message.tableCommon.txnSerialNumber',
            type: 'text',
            filterKey: 'txnId',
          },
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'txnId',
              func: (data) => {
                const params = {
                  id: data.txnId,
                };
                this.$router.push({
                  path: data.txnType === '0005' ? '/transaction/refund/details' : '/transaction/details',
                  query: params,
                });
              },
            },
          ],
        },
        {
          titleBar: { type: 'text', title: 'message.subscription.collectionTime' },
          key: 'txnDate',
          type: 'text',
          textFunc: (data) => data.txnDate || this.noDataString,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.amount' },
          key: 'orderAmount',
          type: 'text',
          textFunc: (data) => `${data.orderCurrency} ${data.orderAmount}`,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'status',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnStatusesList, data.status),
          itemStyle: (data) => this.getHistorySubscriptionStatusStyle(data.status),
        },

      ],
    };
  },
  async created() {
    const { contractId, type } = this.$route.query;
    this.contractId = contractId;
    await this.init();
    if (type === 'edit') {
      this.editClick();
    }
  },
  computed: {
    currLang() {
      const lang = this.$store.getters.app.currentLan;
      const language = lang === 'zh-cn' ? 'zh' : lang;
      return language;
    },
    // 不同语种 文本的宽度不同
    textWidthByLang() {
      const mapper = {
        zh: { width: '120px !important;' },
        en: { width: '160px !important;' },
      };
      return mapper[this.currLang] || { width: '120px !important;' };
    },
  },
  methods: {
    getFrequencyDescription,
    getEnantiomericValue,
    getSubscriptionTxnHistory,
    // 取消订阅
    unsubscribeClick() {
      this.$refs.unsubscribeDialogRefState.open(this.contractId, this.detailState);
    },
    // 打开编辑
    editClick() {
      this.$refs.editDialogRefState.open(this.detailState, this.paymentMethodList);
    },
    clickSideMenu(key) {
      this.sideIndexState = key;
      this.$nextTick(() => {
        const dom = document.querySelector(`.${key}`);
        if (dom) {
          dom.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
      // scrollToDom({ className: key, options: { block: 'nearest', behavior: 'smooth' } });
    },
    async exportClick() {
      await exportSubscriptionDetail(this.contractId);
      ShowSuccessMessage(this.$t('message.common.downloadTask'));
    },
    async getDetail(contractId) {
      const res = await getSubscription(contractId);
      this.detailState = res;
    },
    async getHistoryList(contractId) {
      const res = await getSubscriptionTxnHistory({ contractId });
      this.historyListState = res;
    },
    getSubscriptionStatusStyle(code) {
      const obj = {
        trialing: 'success',
        paymentdue: 'pending',
        active: 'success',
        pastdue: 'fail',
        paused: 'fail',
        canceled: 'disabled',
        ended: 'disabled',
      };
      function getStatusStyle(status) {
        let style = '';
        if (!status) {
          return style;
        }
        switch (status) {
        case 'success':
          style += 'background-color:#D9FFE0';
          break;
        case 'fail':
          style += 'background-color:#FFE8E0';
          break;
        case 'pending':
          style += 'background-color:#E0E0FF';
          break;
        case 'disabled':
          style += 'background-color:#D9D9D9';
          break;
        default:
          break;
        }

        return style ? `height: 24px;padding: 4px 10px;margin-top: 16px;border-radius: 20px 20px 20px 20px;font-family: OPPOSans, OPPOSans;font-weight: bold;font-size: 14px;line-height: 24px;text-align: left;font-style: normal;text-transform: none;text-align: center;${style}` : '';
      }
      console.log(13, code);
      return getStatusStyle(obj[`${code}`]);
    },

    getHistorySubscriptionStatusStyle(code) {
      const obj = {
        S: 'success',
        F: 'fail',
        P: 'pending',
        N: 'fail',
        U: 'pending',
        R: 'disabled',
      };
      function getStatusStyle(status) {
        let style = '';
        if (!status) {
          return style;
        }
        switch (status) {
        case 'success':
          style += 'background-color:#D9FFE0';
          break;
        case 'fail':
          style += 'background-color:#FFE8E0';
          break;
        case 'pending':
          style += 'background-color:#E0E0FF';
          break;
        case 'disabled':
          style += 'background-color:#D9D9D9';
          break;
        default:
          break;
        }

        return style ? `padding:0 10px;height:30px;text-align:center;border-radius:4px;font-weight:800;line-height:30px;${style}` : '';
      }
      return getStatusStyle(obj[`${code}`]);
    },

    async init() {
      try {
        this.pageLoadingState = true;

        const dict = await GlobalData.getDictList(['TXN_STATUS', 'SUBSCRIPTION_STATUS', 'SUBSCRIPTION_PAYMENT_METHOD']);
        this.txnStatusesList = initSelectedData(dict.TXN_STATUS);
        this.statusesList = initSelectedData(dict.SUBSCRIPTION_STATUS);
        this.paymentMethodList = initSelectedData(dict.SUBSCRIPTION_PAYMENT_METHOD);

        await this.getHistoryList(this.contractId);
        this.$refs.tableRefState.setTable(this.historyListState);

        await this.getDetail(this.contractId);
        this.pageLoadingState = false;
      } catch (error) {
        this.pageLoadingState = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  .main-container {
    flex: 1;
    padding: 32px;
    height: calc(100vh - 60px - 50px - 64px);
    overflow: hidden;
    overflow-y: auto;
  }

  .side-menu-container {
    padding: 32px 32px 32px 8px;
    position: sticky;
    top: 100px;
  }
}

.side-menu {
  right: 24px;
  padding: 24px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #EFEFF4;
  width: 260px;

  .text {
    padding: 0px 8px;
    height: 34px;
    line-height: 34px;
    font-family: OPPOSans, OPPOSans;
    font-size: 14px;
    color: #667085;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 8px;
    transition: color 0.3s ease, background-color 0.3s ease;
  }

  .active {
    background: #F6F6FF;
    border-radius: 8px 8px 8px 8px;
    color: #503DF6;
  }

  &:last-child {
    margin-bottom: 0px;
  }
}

.mb-32 {
  margin-bottom: 32px;
}

.header-title {
  font-family: OPPOSans, OPPOSans;
  font-weight: bold;
  font-size: 20px;
  color: #1A202C;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 16px;
}

.cancel-subs-btn {
  width: 100px;
  height: 26px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #D0D5DD;
  font-family: Urbanist, Urbanist;
  font-weight: 400;
  font-size: 14px;
  color: #1A202C;
  line-height: 26px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.cancel-subs-btn:hover {
  border: 1px solid #503DF6;
  color: #2D31A6;
}

.txn-info {
  display: flex;

  .txn-info-item {
    flex: 1;
    border-right: 1px solid #EFEFF4;
    margin-right: 32px;

    &.no-border {
      border-right: none;
    }

    &:last-child {
      border-right: none;
      margin-right: 0px;

    }

    .title {
      font-family: OPPOSans, OPPOSans;
      font-weight: 400;
      font-size: 14px;
      color: #667085;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-bottom: 8px;
    }

    .text {
      font-family: OPPOSans, OPPOSans;
      font-weight: 400;
      font-size: 14px;
      color: #1A202C;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

:deep(.desc-label) {
  display: inline-block;
  font-family: OPPOSans, OPPOSans;
  font-weight: 400;
  font-size: 14px;
  color: #667085;
  line-height: 18px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.pointer {
  cursor: pointer;
}

.operation-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Urbanist, Urbanist;
  font-weight: 400;
  font-size: 16px;
  color: #503DF6;
  line-height: 22px;
  font-style: normal;
  text-transform: none;
  width: 98px;
  height: 38px;

  img {
    margin-right: 4px;
    width: 14px;
    height: 14px;
  }
}

.operation-btn:hover {
  background: #F6F6FF;
  border-radius: 8px 8px 8px 8px;
}
</style>
